export default __webpack_public_path__ + "static/media/BroadStreet.14a6a0f5.jpg";